import React from 'react'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'
import type { Promotion } from '@s4l/stayforlong/marketing/Promotion'

type PromoContextValue = {
  promo?: Promotion
  isLoading: boolean
  error?: Error
  refresh: () => void
}

const PromoContext = React.createContext<PromoContextValue | undefined>(undefined)

export function PromoProvider({
  enabled = true,
  children,
}: {
  readonly enabled?: boolean
  readonly children: React.ReactNode
}) {
  const { data, error, loading, execute } = useUseCase('GetCurrentPromoMarketingUseCase', {
    lazy: !enabled,
  })

  const value = React.useMemo<PromoContextValue>(
    () => ({
      promo: data,
      error,
      isLoading: loading,
      refresh: () => execute(),
    }),
    [data, error, loading, execute]
  )

  return <PromoContext.Provider value={value}>{children}</PromoContext.Provider>
}

export function usePromo() {
  const ctx = React.useContext(PromoContext)
  if (!ctx) {
    return {
      promo: undefined,
      isLoading: false,
      error: undefined,
      refresh: () => undefined,
    }
  }
  return ctx
}
